import api from '../api/client'

const catalogoOnlineConfigService = {
  // Buscar configuração do catálogo online
  getConfig: async (organizadorId) => {
    const response = await api.get(`/configuracoes/catalogo-online/organizadores/${organizadorId}/catalogo-online-config`)
    return response.data
  },

  // Salvar configuração do catálogo online
  saveConfig: async (organizadorId, config) => {
    const response = await api.put(`/configuracoes/catalogo-online/organizadores/${organizadorId}/catalogo-online-config`, config)
    return response.data
  },

  // Buscar regulamento
  getRegulamento: async (organizadorId) => {
    const response = await api.get(`/configuracoes/catalogo-online/organizadores/${organizadorId}/regulamento`)
    return response.data
  },

  // Salvar regulamento (multipart/form-data para PDF)
  saveRegulamento: async (organizadorId, formData) => {
    const response = await api.put(
      `/configuracoes/catalogo-online/organizadores/${organizadorId}/regulamento`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return response.data
  },

  // Salvar cores
  saveCores: async (organizadorId, cores) => {
    const response = await api.put(`/configuracoes/catalogo-online/organizadores/${organizadorId}/cores`, cores)
    return response.data
  },

  // Extrair cores do logo
  extrairCores: async (organizadorId) => {
    const response = await api.post(`/configuracoes/catalogo-online/organizadores/${organizadorId}/extrair-cores`)
    return response.data
  }
}

export default catalogoOnlineConfigService

